import React, { useEffect, useLayoutEffect, useState } from "react";
import whiteYellowLogo from "../assets/images/whiteYellologo.svg";
import NewERPbg from '../../images/360 Degree Erp Logo.png';
import hamburger from "../assets/images/line.png";
import close from "../assets/images/close.png";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
const Header = ({ is360 = false, primaryColor = "#062533", logo }) => {
  const navigate = useNavigate()
  const [menuToggle, setMenuToggle] = useState(false);
  const [windowWidth, setWindowWidth] = useState(null);
  const [firstRender, setFirstRender] = useState(true);


  useEffect(() => {
    if (firstRender) {
      setWindowWidth(window.innerWidth);
      setFirstRender(false);
    }
  }, []);

  return (
    <header>
      <div style={{ backgroundColor: is360 ? "#ffffff" : primaryColor }}>
        <div className=" tw-py-2 tw-mx-[4vw] tw-flex tw-justify-between tw-items-center tw-relative">
          <div className="tw-pb-3">
            <img className={`tw-cursor-pointer ${is360 ? "tw-w-24" : "tw-w-52"}`} src={logo || (is360 ? NewERPbg : whiteYellowLogo)} alt=""  onClick={()=>navigate("/")}/>
          </div>
          <div className="lg:tw-hidden" onClick={() => setMenuToggle(!menuToggle)}>
            <img
              className="tw-w-10"
              src={menuToggle ? close : hamburger}
              alt=""
              srcset=""
            />
          </div>
          {(menuToggle || windowWidth > 1023) && (
            <nav className="max-lg:tw-absolute max-lg:tw-right-0 max-lg:tw-bottom-0 max-lg:tw-translate-y-[100%] max-lg:tw-translate-x-[4vw] tw-lg:tw-w-3/5 xl:tw-w-1/2">
              {/* <ul className="flex text-white lg:gap-5 xl:gap-10 2xl:gap-24 items-center"> */}
              <ul className="tw-flex tw-flex-col lg:tw-flex-row tw-text-white tw-items-center tw-justify-between">
                <li
                  className={`tw-ps-5 tw-cursor-pointer ${
                    windowWidth < 1024 &&
                    "tw-py-[10px] tw-w-44 tw-bg-[#5d3393] active:tw-bg-[#a995c5] tw-border-b"
                  }`}
                >
                  {/* <Link to="/features"> */}
                  {/* <img src={anglepng} alt=">>" className="nav-icon pr-1 " style={{width: "18px"}}/> */}
                  <span className="tw-uppercase">Features</span>
                  {/* </Link> */}
                </li>
                <li
                  className={`tw-ps-5 tw-cursor-pointer ${
                    windowWidth < 1024 &&
                    "tw-py-[10px] tw-w-44 tw-bg-[#5d3393] active:tw-bg-[#a995c5] tw-border-b"
                  }`}
                >
                  {/* <Link to="/pricing"> */}
                  {/* <img src={anglepng} alt=">>" className="nav-icon pr-1 " style={{width: "18px"}}/> */}
                  <span className="tw-uppercase">Pricing</span>
                  {/* </Link> */}
                </li>
                <li
                  className={`tw-ps-5 tw-cursor-pointer ${
                    windowWidth < 1024 &&
                    "tw-py-[10px] tw-w-44 tw-bg-[#5d3393] active:tw-bg-[#a995c5] tw-border-b"
                  }`}
                >
                  {/* <Link to="/knowledgeBase"> */}
                  {/* <img src={anglepng} alt=">>" className="nav-icon pr-1 " style={{width: "18px"}}/> */}
                  <span className="tw-uppercase">Knowledge Base</span>
                  {/* </Link> */}
                </li>
                <li
                  className={`tw-ps-5 tw-cursor-pointer ${
                    windowWidth < 1024 &&
                    "tw-py-[10px] tw-w-44 tw-bg-[#5d3393] active:tw-bg-[#a995c5] tw-border-b"
                  }`}
                >
                  {" "}
                  {/* <Link to="/features"> */}
                  {/* <img src={anglepng} alt=">>" className="nav-icon pr-1 " style={{width: "18px"}}/> */}
                  <span className="tw-uppercase lg:tw-text-[15px] lg:tw-px-14 lg:tw-py-2 lg:tw-rounded-md lg:tw-bg-[#fdd60e]" style={is360 ? { color: "#390098", fontWeight: 700 } : { color: "#062533", fontWeight: 700 }}>
                    Get a Quote
                  </span>
                  {/* </Link> */}
                </li>
              </ul>
            </nav>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
